import { useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import LoginForm from "./login-form";

const SaloonLogin = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (videoRef) videoRef?.current?.play();
  }, [videoRef]);
  return (
    <div className="w-full min-h-screen flex flex-wrap lg:items-center">
      <div className="hidden md:block w-full min-h-40 lg:min-h-screen lg:w-6/12 relative bg-saloon-btn px-4 md:px-0">
        <img
          src="/png/animations.png"
          className="opacity-25 m-auto lg:h-screen w-full hidden lg:block"
          alt="animations"
        />
        <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 mx-auto text-center">
			<img
              alt="hotel agent logo"
              src="/svg/logo.svg"
              className="mx-auto max-w-[75%]"
            />
        </div>
      </div>
      <div className="w-full lg:h-full lg:w-6/12 px-4 md:px-0 m-auto md:m-none">
        <LoginForm />
        <div className="my-5 py-1 text-center border-t border-borderColor-default w-4/12 mx-auto">
          or{" "}
          <NavLink to="/sign-up" className="underline">
            Sign up
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default SaloonLogin;
